import styled from 'styled-components'
import Select from 'react-select'
import { Controller } from 'react-hook-form'

const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: ${(props) => props.width || '100%'};

  .label {
    font-size: 12px;
    /* padding-inline: 18px; */
    color: #2d2d2d;
    font-weight: 600;
  }

  .select {
    border: none;
    font-size: 12px;
    color: #2d2d2d;
    padding-block: 6px;
    padding-inline: 6px;
    background-color: #fff;

    width: ${(props) => props.width || '100%'};
    outline: none;
  }
`

export const SelectComponent = (props) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      defaultValue=""
      render={({ field }) => (
        <GroupInput width={props.width} error={props.error}>
          <label htmlFor={props.id || props.label} className="label">
            {props.label}
          </label>
          <Select
            placeholder={props.placeholder || 'Selecione...'}
            styles={{
              control: (styles) => ({
                ...styles,
                height: '30px',
                width: '100%',
                minHeight: '32px',
                borderRadius: '0',
                boxShadow: 'none',
                borderColor: props.error ? '#ff0000' : '#CFCFCF',
                '&:hover': {
                  borderColor: '#ffa200',
                },
              }),
              indicatorSeparator: (styles) => ({
                ...styles,
                display: 'none',
              }),
              dropdownIndicator: (styles) => ({
                ...styles,
                padding: '5px',
              }),
              valueContainer: (styles) => ({
                ...styles,
                padding: '0 6px',
              }),
              container: (styles) => ({
                ...styles,
                padding: '0px!important',
                width: '100%',
              }),

              input: (styles) => ({
                ...styles,
                padding: '0',
              }),
              menu: (styles) => ({
                ...styles,
                marginTop: '2px',
              }),
              option: (styles, { isFocused, isSelected }) => ({
                ...styles,
                backgroundColor: isSelected ? '#ffa200' : isFocused ? '#f7f7f7' : 'white',
                color: isSelected ? 'white' : '#2d2d2d',
                cursor: 'pointer',
              }),
            }}
            id={props.id || props.label}
            onChange={(e) => field.onChange(e)}
            {...props}
            {...field}
            className="select"
          >
            {/* defaulkt */}
            <option value="">Selecione...</option>
            {props.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </GroupInput>
      )}
    />
  )
}
